import React, { useCallback, useState } from 'react';
import { Icon, GLYPHS } from 'components/Shared/Icon';
import { AdElement } from './AdElement';

export const FixedLargeMobileBanner = ({ id, height, width }) => {
    const enabled = process.env.NODE_ENV === 'production';
    const [open, setOpen] = useState(true);
    const close = useCallback(() => setOpen(false), [setOpen]);
    return (
        open && (
            <div className="container-gas container-gas-mobile-banner">
                <button className="container-gas-close" onClick={close}>
                    <Icon glyph={GLYPHS.CLOSE} />
                </button>
                <div className="gas-label">ADVERTISEMENT</div>
                <div className="gas-mobile-banner">
                    {!enabled && (
                        <img src={`https://via.placeholder.com/${width}x${height}?text=Test%20Ad`} alt="Test Ad" />
                    )}
                    {enabled && (
                        <div id={id} style={{ height: `${height}px`, width: `${width}px`, display: 'inline-block' }}>
                            <AdElement
                                client="ca-pub-5077429869863377"
                                slot="3712925246"
                                responsive="true"
                                format="horizontal"
                                pageLevelAds
                            />
                        </div>
                    )}
                </div>
            </div>
        )
    );
};
